import React from 'react';
import WithPermission from 'hocs/WithPermission';
import PropTypes from 'prop-types';

import Loader from '../Loader/Loader';

import Add24 from 'icons/Add24';

import classNames from 'utils/classNames';

import styles from './icon_button.scss';

function IconButton(props) {
    const { accent, loading, disabled, onDark } = props;

    function handleClick(e) {
        if (props.onClick !== undefined && typeof props.onClick === 'function') {
            if (!disabled && !loading) {
                props.onClick(e);
            }
        }
    }
    const classes = classNames(styles.button, {
        [styles.accent]: accent,
        [styles.disabled]: disabled,
        [styles.loading]: loading,
        [styles.onDark]: onDark,
    });

    return (
        <div className={classes} onClick={handleClick}>
            <div className={classNames(styles.icon, {
                [styles.accent]: accent,
                [styles.onDark]: onDark,
            })}>
                {!loading && props.icon}
                {loading && <Loader dark={true} />}
            </div>
        </div>
    );
};

IconButton.propTypes = {
    /**
     * Icon component.
     */
    icon: PropTypes.element.isRequired,
    /**
     * Should button be filled with accent color.
     */
    accent: PropTypes.bool,
    /**
     * Is button in loading proccess.
     */
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    /**
     * Changes icons color to light, when button displayed on dark surface.
     */
    onDark: PropTypes.bool,
};

IconButton.defaultProps = {
    icon: <Add24 />,
    accent: false,
    loading: false,
};

export default WithPermission(IconButton);
